export const INCORRECT_MASTER_KEY = "Incorrect Master Key";

export class CryptoError extends Error {
  constructor(message, cause) {
    super(message);
    this.name = new.target.name;
    if (cause !== undefined) this.cause = cause;
  }
}

export class CryptoInitializationError extends CryptoError {}
export class CryptoValidationError extends CryptoError {}
